export default function(n) {
  var s = String(n).split('.'), v0 = !s[1];
  return n == 1 && v0 ? 'one' : 'other';
}
